import React, { lazy } from 'react';
interface HeroSectionProps {
  onOpenModal: () => void;
}
export function HeroSection({
  onOpenModal
}: HeroSectionProps) {
  return <section className="pt-16 md:pt-24 pb-20 px-6 md:px-8 text-center max-w-4xl mx-auto" data-id="element-80">
      <h2 className="text-green-600 text-xs md:text-sm font-semibold mb-8 tracking-[0.2em] uppercase" data-id="element-81">
        Exclusively For Accredited Investors With Capital Ready To Deploy
      </h2>

      <h1 className="text-[2rem] sm:text-[2.5rem] md:text-[3.25rem] lg:text-[4rem] font-serif font-black text-gray-900 leading-[1.12] tracking-tight mb-8" data-id="element-82">
        Acquire A Profitable Business With An Institutional M&A Team Handling
        The Entire Process.
      </h1>

      <h2 className="text-gray-600 text-lg md:text-2xl leading-relaxed max-w-2xl mx-auto mb-14 font-normal" data-id="element-83">
        From off market deal sourcing to negotiation and closing, we act as your
        dedicated buy side acquisition partner.
      </h2>

      {/* Video Embed */}
      <div className="max-w-3xl mx-auto mb-14" data-id="element-84">
        <div style={{
        position: 'relative',
        paddingTop: '56.25%'
      }} data-id="element-85">
          <iframe src="https://iframe.mediadelivery.net/embed/549446/f4edf182-6ecb-4067-99cb-33f2c9bbd384?autoplay=true&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
          border: 0,
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%'
        }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen data-id="element-86" />
        </div>
      </div>

      <div className="flex justify-center" data-id="element-87">
        <button onClick={onOpenModal} className="inline-flex items-center justify-center px-14 py-8 md:px-20 md:py-10 text-xl md:text-2xl font-bold rounded-full bg-green-600 text-white hover:bg-green-700 hover:shadow-[0_0_30px_rgba(22,163,74,0.3)] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600 focus:ring-offset-white" data-id="element-88">
          Speak With Our M&A Team →
        </button>
      </div>
    </section>;
}